import {
  ComingNomenclatureReportType,
  InvoiceParams,
  InvoiceParamsRequest,
  InvoiceParamsRequestPreInfo,
  ReportPassport,
  ReportPassportRequest,
  SetReportPassportRequest,
  TtnParameter,
  TtnParameterSetRequest,
} from 'bus/report/types';

import $axios from '../utils/axios-instance';

export default class ShiftApi {
  async getReportTtnParameters(data: Pick<TtnParameterSetRequest, 'requestWorkId'>) {
    return await $axios
      .get<TtnParameter>(`/v1/Report/ttnParameters/${data.requestWorkId}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async setReportTtn(data: TtnParameterSetRequest) {
    return await $axios
      .post<Blob>(`/v1/Report/ttn/${data.requestWorkId}?version=${data.version}`, data, { responseType: 'blob' })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingNomenclatureReport({ dateBegin, dateEnd }: ComingNomenclatureReportType) {
    return await $axios
      .get<Blob>(`/v1/Report/comingNomenclatureReport?dateBegin=${dateBegin}&dateEnd=${dateEnd}`, {
        responseType: 'blob',
      })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getComingInvoiceParams(data: InvoiceParamsRequest) {
    return await $axios
      .get<InvoiceParams>(`/v1/Report/invoice/${data.requestWorkId}/parameters`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingInvoiceReport(data: InvoiceParamsRequestPreInfo) {
    return await $axios
      .post<Blob>(`/v1/Report/invoice/${data.requestWorkId}`, data, { responseType: 'blob' })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getReportPassport(data: ReportPassportRequest) {
    return await $axios
      .get<ReportPassport>(`/v1/Report/passport/${data.requestWorkId}/parameters`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async setReportPassport(data: SetReportPassportRequest) {
    return await $axios
      .post<Blob>(`/v1/Report/passport/${data.requestWorkId}`, data, { responseType: 'blob' })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
